import React from 'react';
import { styled } from '@linaria/react';
import { GetTheAppButtons } from 'components/GetTheAppButtons/GetTheAppButtons';
import ContentWrapper from '@daedalus/atlas/helpers/ContentWrapper';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { Text } from '@daedalus/atlas/Text';
import { Placement } from '@daedalus/core/src/deepLinking/types';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
interface Props {
  isSingleColumn: boolean;
}
export const FooterGetTheAppSection = ({
  isSingleColumn
}: Props) => {
  return <Wrapper>
      <Text variant="titleL">
        <FormattedMessageWrapper id="appBanner.button" defaultMessage="Get the app" />
      </Text>
      <ContentWrapper paddingTop="s400">
        <Flex.Row justifyContent={isSingleColumn ? 'center' : 'flex-start'}>
          <GetTheAppButtons alwaysShowButtons placement={Placement.Footer} />
        </Flex.Row>
      </ContentWrapper>
    </Wrapper>;
};
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w191ob05",
  propsAsIs: false
});

require("./GetTheAppSection.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./GetTheAppSection.tsx");